
import Swiper, { Navigation, Pagination, EffectFade, Controller, Autoplay } from 'swiper';
import MmenuLight from  '../../node_modules/mmenu-light/src/mmenu-light.js';
import MicroModal from 'micromodal';
import Rellax from  '../../node_modules/rellax/rellax.min.js';
import { toggleAccordion, bindEvent } from './accordion'
import debounce from 'lodash/debounce'
import { addModelToFavourites, watchFavourites } from '../vue/favourites/State'

Swiper.use([Navigation, Pagination, EffectFade, Controller, Autoplay]);

// Scripts to fire once dom has loaded
document.addEventListener("DOMContentLoaded", () => {
    watchFavourites()
    document.querySelectorAll('[data-favourites-id]').forEach(x => {
        x.addEventListener('click', e => {
            e.preventDefault()
            const id = e.target.closest('[data-favourites-id]').dataset.favouritesId
            addModelToFavourites(id)
        })
    })

    function waitForElement(selector) {
        return new Promise(resolve => {
            if (document.querySelector(selector)) {
                return resolve(document.querySelector(selector));
            }

            const observer = new MutationObserver(() => {
                if (document.querySelector(selector)) {
                    resolve(document.querySelector(selector));
                    observer.disconnect();
                }
            });

            observer.observe(document.body, {
                childList: true,
                subtree: true
            });
        });
    }

    if (document.getElementById('apsr_placeholder')) {
        waitForElement('link[href*="autoplay.co.nz"]')
            .then(() => {
                const ourCssFiles = document.
                    querySelectorAll('link[rel="stylesheet"]:not(link[href*="autoplay.co.nz"])')
                ourCssFiles.forEach(file => document.head.append(file))
            })
    }

    // Parallax
    const productCards = document.querySelectorAll('.parallax');

    if ( productCards ) {
        var rellax = new Rellax('.rellax', {
          center:true, 
          breakpoints:[576, 768, 1024],
        }); 
    }

    window.onresize = debounce(resizeGradient, 1000)
    function resizeGradient() {
        const introductionModules = document.querySelectorAll('.module.introduction')
        introductionModules.forEach(module => {
            const megaMenu = module.closest('.mega-menu-wrapper')
            const rightPos = module.getBoundingClientRect().right
            megaMenu.style.background =
                `linear-gradient(to right, #E3E1DB 0px, #E3E1DB ${rightPos}px, white ${rightPos}px)`
        })
    }

    resizeGradient()


    const newsletterBtn = document.querySelector('[newsletter-button]')
    const newsletterPopup = document.querySelector('[newsletter-popup]')
    const newsletterContent = document.querySelector('[popup-content]')
    function toggleNewsletterPopup() {
        newsletterPopup.classList.toggle('open')
        //newsletterPopup.classList.toggle('flex')
        document.body.classList.toggle('overflow-y-hidden')
    }
    bindEvent(newsletterBtn, 'click', toggleNewsletterPopup)
    bindEvent(newsletterPopup, 'click', toggleNewsletterPopup)
    bindEvent(newsletterContent, 'click', function(e) {
        if (e.target.hasAttribute('popup-close')) return
        e.stopPropagation()
    })
    

    // Mega menu
    var panels = document.querySelectorAll('.panel');
    var panelTriggers = document.querySelectorAll('.js-panel-btn');
    var sectionHeader = document.querySelector('.section-header');
    var subPanelOverlay = document.querySelector('.navigation-overlay');

    // Mega menu top level
    if (panelTriggers) {

        for (let i = 0, l = panelTriggers.length; i < l; i += 1) {
            panelTriggers[i].addEventListener('click', (event) => {

                event.preventDefault();

                const panelId = event.currentTarget.dataset.panelId;
                const panel = document.getElementById(`panel-${panelId}`);
                const link = document.getElementById(`link-${panelId}`);
                const linkActive = link.classList.contains('is-active') ? true : false;

                if (linkActive) {
                    panel.classList.remove('active');
                    link.classList.remove('is-active');
                    projectWrapper.classList.remove('active');
                }

                else {
                    removeMenus();
                    panel.classList.add('active');
                    link.classList.add('is-active');
                    projectWrapper.classList.add('active');
                }

                if (navTrigger.classList.contains('is-active')) {
                    drawer.open();
                    navTrigger.classList.remove('is-active');
                    projectWrapper.classList.remove('js-is-open');
                    drawer.close();
                }

            });
        }

        sectionHeader.addEventListener('mouseleave', (event) => { 
            removeMenus();
        });
    
    }

    function removeMenus() {
        panels.forEach(item => {
            item.classList.remove('active');
        })
        panelTriggers.forEach(item => {
            item.classList.remove('is-active');
        })

        projectWrapper.classList.remove('active');
    }


    // Mobile menu init // Sync search and menu open
    const menu = new MmenuLight( document.querySelector( "#mobile-menu" ), "(max-width: 1024px)" );
    const navigator = menu.navigation();
    const drawer = menu.offcanvas();

    //Open Menu
    const navTrigger = document.querySelector('.js-open-nav');
    const projectWrapper = document.getElementById('app');

    //Toggle Menu
    bindEvent(navTrigger, "click", function() {
        this.classList.toggle('is-active');
        projectWrapper.classList.toggle('js-is-open');

        if (this.classList.contains('is-active')) {
            drawer.open();
            removeMenus();
        } else {
            drawer.close();
        }

    });

    MicroModal.init({
        onClose: modal => stopVideo(modal),
        onShow: modal => playVideo(modal),
    });

    function stopVideo(modal) {
        const video = modal.querySelector('iframe')
        if (!video) return
        video.contentWindow.postMessage('{"event":"command","func":"stopVideo","args":""}', '*')
    }

    function playVideo(modal) {
        const video = modal.querySelector('iframe')
        if (!video) return
        video.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*')
    }

    // wrapping tables in divs
    const table = document.querySelectorAll('.wysiwyg-block table')

    table.forEach(item => {  
        const wrapper = document.createElement("div");
        item.parentNode.insertBefore(wrapper, item);
        wrapper.appendChild(item);

        item.parentNode.classList.add('table-wrapper');
    });
    

    // below could all move into the results vue js file //
    const breakpoint = window.matchMedia( '(min-width:1280px)' );// keep track of swiper instances to destroy later
    let productSwipers
    let observer

    function breakpointChecker() {
        if (breakpoint.matches === false) return enableSwiper()
        if (productSwipers === undefined) return
        observer?.disconnect()
        observer = null
        if (productSwipers.length) return productSwipers.forEach(x => x.destroy())
    }

    function initSwiper() {
        productSwipers = new Swiper ('.swiper-products', {
            slidesPerView: 'auto',
            a11y: true,
            keyboardControl: true,
            grabCursor: true,
        });
    }

    initSwiper()

    const enableSwiper = function() {
        observer = new MutationObserver(initSwiper)

        const filterApp = document.getElementById('filterVueApp')

        observer.observe(filterApp, { subtree: true, childList: true })
        initSwiper()
    };

    if (document.getElementById('filterVueApp')) {
        // keep an eye on viewport size changes
        breakpoint.addListener(breakpointChecker);// kickstart
        breakpointChecker();
    }

  
    // hide or remove squiggly line
    function checkHeight() {
        var parentHeightB = document.getElementById('content')?.clientHeight;
        var parentHeightA = document.getElementById('content')?.clientHeight;

        if(parentHeightB && document.getElementById('device-b')) {
            if (parentHeightB > 1446) {
                document.getElementById('device-b').style.display = "block";
            } else {
                document.getElementById('device-b').style.display = "none";
            }
        }

        if(parentHeightA && document.getElementById('device-a')) {
            if (parentHeightA > 610) {
                document.getElementById('device-a').style.display = "block";
            } else {
                document.getElementById('device-a').style.display = "none";
            }
        }

    }

    checkHeight();

    // Accordions
    const accordionItems = document.querySelectorAll('[data-accordion-item]');

    if (accordionItems.length) {
        accordionItems.forEach(function(accordion) {
            const accordionLink = accordion.firstElementChild;
            bindEvent(accordionLink, 'click', toggleAccordion);
        });
    }

    let form = document.querySelectorAll("[data-handle='productConfigurator']");

    if (form.length) {
        let submitBtn = form[0].querySelector('button[type="submit"]')
        let productDetailsHidden = form[0].querySelector('#chosenOptions-handle')
        let submissionUrlHidden = form[0].querySelector('#submissionUrl-handle')
        let submissionTimeHidden = form[0].querySelector('#submissionTime-handle')

        if (submitBtn && submissionTimeHidden && productDetailsHidden && submissionUrlHidden) {
            submissionTimeHidden.parentElement.classList.add("hidden")
            submissionUrlHidden.parentElement.classList.add("hidden")
            productDetailsHidden.parentElement.classList.add("hidden")
            productDetailsHidden.style.whiteSpace = 'pre-wrap';
            submitBtn.addEventListener('click', function (event) {

                var detailsJson = {
                    product: document.querySelector('#configurator-product-title')?.getInnerHTML(),
                    productId: document.querySelector('#configurator-product-id')?.getInnerHTML(),
                    basePrice: document.querySelector('#configurator-product-baseprice')?.getInnerHTML(),
                    addOns: [].map.call(document.querySelectorAll('.addOns-customiser'), function (el) {
                        return el.outerHTML;
                    }).join(""),
                    totalEstimatedPrice: document.querySelector('#configurator-product-totalprice')?.getInnerHTML(),
                }

                productDetailsHidden.value = JSON.stringify(detailsJson)
                submissionTimeHidden.value = Date.now()
                submissionUrlHidden.value = "https://www.traillite.co.nz/customise/submission/" + submissionTimeHidden.value


            });
        }

    }
})
